import { tableFrCATranslations } from "@components";
import { draftFrCATranslations } from "@hooks";

export default {
  ...tableFrCATranslations,
  ...draftFrCATranslations,
  "Delete Item": "Supprimer l'élément",
  countries: {
    canada: "Canada",
    unitedStates: "États-Unis",
  },
  states: {
    canada: {
      ab: "Alberta",
      bc: "Colombie-Britannique",
      mb: "Manitoba",
      nb: "Nouveau-Brunswick",
      nl: "Terre-Neuve-et-Labrador",
      ns: "Nouvelle-Écosse",
      nt: "Territoires du Nord-Ouest",
      nu: "Nunavut",
      on: "Ontario",
      pe: "Île-du-Prince-Édouard",
      qc: "Québec",
      sk: "Saskatchewan",
      yt: "Yukon",
    },
    unitedStates: {
      al: "Alabama",
      ak: "Alaska",
      az: "Arizona",
      ar: "Arkansas",
      ca: "Californie",
      co: "Colorado",
      ct: "Connecticut",
      de: "Delaware",
      fl: "Floride",
      ga: "Géorgie",
      hi: "Hawaï",
      id: "Idaho",
      il: "Illinois",
      in: "Indiana",
      ia: "Iowa",
      ks: "Kansas",
      ky: "Kentucky",
      la: "Louisiane",
      me: "Maine",
      md: "Maryland",
      ma: "Massachusetts",
      mi: "Michigan",
      mn: "Minnesota",
      ms: "Mississippi",
      mo: "Missouri",
      mt: "Montana",
      ne: "Nebraska",
      nv: "Nevada",
      nh: "New Hampshire",
      nj: "New Jersey",
      nm: "Nouveau-Mexique",
      ny: "New York",
      nc: "Caroline du Nord",
      nd: "Dakota du Nord",
      oh: "Ohio",
      ok: "Oklahoma",
      or: "Oregon",
      pa: "Pennsylvanie",
      ri: "Rhode Island",
      sc: "Caroline du Sud",
      sd: "Dakota du Sud",
      tn: "Tennessee",
      tx: "Texas",
      ut: "Utah",
      vt: "Vermont",
      va: "Virginie",
      wa: "Washington",
      wv: "Virginie-Occidentale",
      wi: "Wisconsin",
      wy: "Wyoming",
    },
  },
  language: "fr-CA",
  languageWord: "Français",
  global: {
    addressLineOne: "Adresse Ligne Un",
    addressLineTwo: "Adresse Ligne Deux",
    back: "Retour",
    city: "Ville",
    country: "Pays",
    email: "E-mail",
    invupme: "invup",
    invoice: "Facture",
    maxLengthFieldErrorMessage:
      "Ce champ a dépassé la longueur maximale de caractères.",
    maxLengthWithValueFieldErrorMessage:
      "Ce champ ne peut accepter que {{value}} caractères.",
    name: "Nom",
    patternFieldErrorMessage: "Ce champ ne correspond pas au modèle requis.",
    phoneNumber: "Téléphone",
    requiredFieldErrorMessage: "{{value}} est requis.",
    continue: "Continuer",
    state: "État/Province",
    tagLine: "Slogan",
    zipCode: "Code postal",
    weSentYouAPasscode: "Nous vous avons envoyé un e-mail avec un code d'accès",
    organizationName: "Nom de l'organisation",
  },
  login: {
    welcomeBack: "Connectez-vous à Invup",
    pleaseProvideEmail:
      "Veuillez fournir votre adresse e-mail pour vous connecter",
    createNewAccount: "Créer un nouveau compte",
  },
  signup: {
    welcomeToInvup: "Bienvenue sur Invup",
    pleaseProvideEmail:
      "Veuillez fournir votre adresse e-mail pour créer un compte",
    useExitingAccount: "Connectez-vous avec un compte existant",
  },
  newOrganization: {
    getStartedTitle: "Commençons",
    getStartedMessage: "Créez votre première organisation pour commencer !",
    createOrganization: "Créer une organisation",
    createNewOrganizationTitle: "Créer une nouvelle organisation",
    createNewOrganizationMessage:
      "Ajoutez une autre organisation à votre compte",
  },
};
